module.exports = __webpack_public_path__ + "static/img/2.7574c91.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos/2.png
// module id = kmhf
// module chunks = 0